<header class="app-header ng-tns-c47-0 pt-0 mt-0 sticky-top">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light">
        <!-- Container wrapper -->
        <div class="container-fluid">
            <!-- Collapsible wrapper -->
            <div id="navbarSupportedContent">
                <!-- Navbar brand -->
                <span *ngIf="!(redirectionRoute$ | async)" class="navbar-brand p-0">
                    <img
                        alt="Uniqode Logo"
                        height="30"
                        src="/logo/uniqode-small-logo-white.svg"
                        width="30"
                    />
                </span>
                <button *ngIf="redirectionRoute$ | async" class="btn btn-transparent navbar-brand p-0" (click)="handleBackButtonRedirection()">
                    <img
                        alt="Back button redirection"
                        height="23"
                        width="23"
                        src="/img/icons/back-arrow-white.svg"
                    />
                </button>
            </div>
            <!-- Collapsible wrapper -->
            <div *ngIf="isLoading$ | async" class="d-flex align-items-center">
                <ngx-skeleton-loader
                    [count]="1"
                    [animation]="'pulse'"
                    [appearance]="'circle'"
                    [theme]="{ width: '32px', height: '32px' }"
                ></ngx-skeleton-loader>
            </div>

            <!-- Right elements -->
            <div *ngIf="!(isLoading$ | async)">
                <div *ngIf="navigator.onLine">
                    <div
                        *ngIf="isLoggedIn$ | async"
                        class="d-flex align-items-center"
                    >
                        <!-- Avatar -->
                        <div
                            (click)="handleAccountsDrawer()"
                            (keydown)="handleAccountsDrawer()"
                            (keyup)="handleAccountsDrawer()"
                            class="dropdown"
                        >
                            <div class="rounded-circle avatar">
                                <img
                                    *ngIf="user?.profile_picture"
                                    [src]="user?.profile_picture"
                                    alt="Profile"
                                    class="img-avatar pointer-events-none"
                                />
                                <div
                                    *ngIf="
                                        !user.profile_picture &&
                                        (user.first_name || user.last_name)
                                    "
                                    class="img-avatar pointer-events-none d-inline"
                                    id="profile-info"
                                >
                                    {{ user.first_name[0]
                                    }}{{ user.last_name[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        *ngIf="!(isLoggedIn$ | async)"
                        class="d-flex justify-content-center align-items-center gap-12"
                        (click)="redirectToLogin()"
                    >
                        <img
                            src="/icons/dbc/user_avatar.svg"
                            alt="login-avatar"
                        />
                        <span class="login-text">Login</span>
                    </div>
                </div>
                <div *ngIf="!navigator.onLine">
                    <img src="/icons/dbc/no-connection.svg" alt="offline" />
                </div>
            </div>
            <!-- Right elements -->
        </div>
        <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->

    <pwa-install-nudge></pwa-install-nudge>
</header>

<account-drawer-component
    *ngIf="isLoggedIn$ | async"
    (onOutsideClick)="handleOutsideClickOfAccountDrawer($event)"
    [openAccountsDrawer]="openAccountsDrawer"
></account-drawer-component>
